import { Component } from '@angular/core';

@Component({
  selector: 'edm-menuitem-layout',
  template: `
    <ngx-one-column-layout>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
  styles: [`
    :host ::ng-deep nb-layout-column {
      padding: 0 !important;
    }
  `],
  standalone: false,
})
export class MenuItemLayoutComponent {}
